import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "group", "item", "empty"];
  static values = { noun: String };

  filter() {
    const raw = this.inputTarget.value.trim();
    const query = raw.toLowerCase();
    let anyVisible = false;

    this.groupTargets.forEach((group) => {
      let groupVisible = false;

      this.itemTargets.filter((item) => group.contains(item)).forEach((item) => {
        const match = !query || item.dataset.search.includes(query);
        item.classList.toggle("d-none", !match);
        if (match) groupVisible = true;
      });

      group.classList.toggle("d-none", !groupVisible);
      if (groupVisible) anyVisible = true;
    });

    this.emptyTarget.textContent = `No ${this.nounValue || "results"} match “${raw}”.`;
    this.emptyTarget.classList.toggle("d-none", anyVisible);
  }
}
